import {
  SalesforceActions,
  IntegrationField,
} from 'module/api/integrations/salesforce/types';

export const getFields = (salesForceType: SalesforceActions): string => {
  switch (salesForceType) {
    case SalesforceActions.Account:
      return 'accountFields';
    case SalesforceActions.Contact:
      return 'contactFields';
    default:
      return 'rocketlaneFields';
  }
};

export const getFieldType = (
  salesForceType: SalesforceActions,
): 'projects' | 'company' | 'user' => {
  switch (salesForceType) {
    case SalesforceActions.Account:
      return 'company';
    case SalesforceActions.Contact:
      return 'user';
    default:
      return 'projects';
  }
};

export const combineFields = (allFields: {
  projects: IntegrationField[];
  company: IntegrationField[];
  user: IntegrationField[];
}): IntegrationField[] => [
  ...allFields.projects,
  ...allFields.company,
  ...allFields.user,
];
